import type { PhoneConfirmation } from '../api/types';
import { fmtDateTime } from './format';

// Telefonische Terminbestätigung durch den Support (OFFENE_FRAGEN B-29): Stand in Worten – „nicht erreicht“ ist keine Absage.

export interface PhoneConfirmationView {
  label: string;
  text: string;
  tone: 'ok' | 'warn' | 'error' | 'muted' | 'info';
}

export function phoneConfirmationView(c: PhoneConfirmation, now: Date = new Date()): PhoneConfirmationView | null {
  const by = c.by_name ? ` von ${c.by_name}` : '';
  switch (c.status) {
    case 'OPEN': {
      const overdue = !!c.due_at && new Date(c.due_at) < now;
      return overdue
        ? { label: 'Überfällig', text: `Noch nicht telefonisch bestätigt – fällig war ${fmtDateTime(c.due_at)}.`, tone: 'error' }
        : { label: 'Offen', text: `Die Terminplanung ruft den Kunden an – fällig ${fmtDateTime(c.due_at)}.`, tone: 'warn' };
    }
    case 'NOT_REACHED':
      return {
        label: 'Nicht erreicht',
        text: `Kunde nicht erreicht (${c.attempts}×${c.at ? `, zuletzt ${fmtDateTime(c.at)}` : ''}${by}). Der Termin bleibt bestehen.`,
        tone: 'warn',
      };
    case 'CONFIRMED':
      return { label: 'Bestätigt', text: `Telefonisch bestätigt${c.at ? ` am ${fmtDateTime(c.at)}` : ''}${by}.`, tone: 'ok' };
    case 'CANCELED':
      return { label: 'Abgesagt', text: `Im Bestätigungsanruf abgesagt${by}.`, tone: 'error' };
    case 'MISSED':
      return { label: 'Nicht bestätigt', text: 'Nicht telefonisch bestätigt – der Termin hat begonnen.', tone: 'muted' };
    default:
      return null;
  }
}

// confirmationOpen: Es ist noch anzurufen bzw. erneut zu versuchen.
export function confirmationOpen(c: PhoneConfirmation | null | undefined): boolean {
  return !!c && (c.status === 'OPEN' || c.status === 'NOT_REACHED');
}
